window.axios = require("axios");
window._ = require("lodash");
window.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
window.axios.defaults.headers.common[
  "Authorization"
] = `Bearer ${window.localStorage.getItem("token")}`;
